import { Box } from '@lifechurch/react-ion';
import StyledTableBody from '@components/Table/TableBody';
import { SubscriberNodeFieldsFragment, SubscribersQuery } from '@generated/types';
import TableRow from '@components/Users/TableRow';
import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';

interface Props {
  data?: SubscribersQuery;
}

const TableBody: FC<Props> = ({ data }) => {
  const { t } = useTranslation(['users', 'common']);

  if (!data?.currentOrganization?.subscribers) return null;

  if (data.currentOrganization.subscribers.edges?.length === 0) {
    return (
      <Box backgroundColor='white' borderRadius={2} boxShadow={1} py={5} px={5} textAlign='center'>
        {t('no_results_were_found')}
      </Box>
    );
  }

  return (
    <StyledTableBody data-testid='usersTable'>
      {data.currentOrganization.subscribers.edges?.map(
        (subscriber: SubscriberNodeFieldsFragment | null | undefined) => (
          <TableRow key={subscriber?.node?.id} subscriber={subscriber} />
        )
      )}
    </StyledTableBody>
  );
};

export { TableBody };
